// extracted by mini-css-extract-plugin
export var label = "_gy-2";
export var slideContainer = "_gy-0";
export var slider = "_gy-1";